import { ThemeProvider, createTheme, darken } from "@mui/material";
import { ReactNode, useEffect, useMemo } from "react";
import theme from "./mui/theme";

export default function CustomBookingThemeProvider({
  customizationEnabled,
  customizationPrimaryColor,
  children,
}: {
  customizationEnabled: boolean;
  customizationPrimaryColor: string;
  children: ReactNode;
}) {
  useEffect(() => {
    if (customizationEnabled && customizationPrimaryColor) {
      document.documentElement.style.setProperty(
        "--moxie-primary-color",
        customizationPrimaryColor
      );
    }
  }, [customizationEnabled, customizationPrimaryColor]);

  const customBookingTheme = useMemo(() => {
    return createTheme(
      theme,
      customizationEnabled && customizationPrimaryColor
        ? {
            palette: {
              primary: {
                main: customizationPrimaryColor,
              },
            },
            components: {
              MuiButton: {
                styleOverrides: {
                  contained: {
                    "&:hover": {
                      backgroundColor: darken(customizationPrimaryColor, 0.2),
                    },
                  },
                  outlined: {
                    color: customizationPrimaryColor,
                  },
                },
              },
            },
          }
        : {}
    );
  }, [customizationEnabled, customizationPrimaryColor]);

  return <ThemeProvider theme={customBookingTheme}>{children}</ThemeProvider>;
}
